// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"style_breadcrumbs__1swDO","path":"style_path__3-27D","arrow":"style_arrow__3gjvR"};